import styled from "styled-components";

const WhiteSpaceBottom = styled.div`
  width: 100%;
  margin-bottom: 130px;
`;

export default WhiteSpaceBottom;
